import { verifyUser } from "core/services/api"
import React, { useState, useEffect } from "react"
import { useLocation } from "react-router"
import { useHistory } from "react-router"
import "./UserVerification.scss"
import Button from "react-bootstrap/esm/Button"

const UserVerification: React.FunctionComponent<any> = () => {
  const [message, setMessage] = useState("")
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(true);
  const history = useHistory()

  const location = useLocation()
  let temptoken: any = new URLSearchParams(location.search).get("token")
  temptoken = temptoken?.replaceAll(" ", "+");


  useEffect(() => {
    const payload_verificationToken = {
      verificationCode: temptoken,
    }

    verifyUser(payload_verificationToken)
      .then((res: any) => {
        console.log(res)
        setSuccess(true)
        setMessage("User verified successfully. Please click below to Login")
        setLoading(false);
      })
      .catch((err: any) => {
        console.log(err, "error")
        setMessage(err?.response?.data?.message)
        setLoading(false);
      })
  }, [])

  const handleLogin = () => {
    history.replace('/login');
  };
  return (
    <div className="verification-container col-md-4 col-sm-4 col-xs-4">
      {loading ? ( // Display loader while loading is true
        <p>Please wait while we are verifying you...</p>
      ) : success ? (
        <p>
          {message}
          {/* <a href={`${process.env.REACT_APP_WEB_API}`}>Login</a> */}
        </p>
      ) : (
        <p>{message}</p>
      )}
      <Button onClick={handleLogin}>Login</Button>
    </div>
  )
}

export default UserVerification